import * as yup from "yup";

export const editValidationSchema = yup.object().shape({
  name: yup
    .string()
    .min(2, "Tên địa bàn phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập tên địa bàn"),
});
